import type { NextPage } from 'next'
import style from './item.module.css'


interface IProps {
    className?: string
    title?: string
}

const Component: NextPage<IProps> = ({ className, title }) => {
    return (
        <section className={className || ''}>
            <table className={`${style.baseInfoTable} border-t-2 border-t-gg-blue`}>
                <tbody>
                    <tr>
                        <td className="py-[240px] text-center">등록된 {title && title} 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
        </section>
    )
}

export default Component
